module.exports = __webpack_public_path__ + "static/media/bigcommerce-logo.48b6e6be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/bigcommerce-logo.svg
// module id = 610
// module chunks = 0